var hash_tops = [];
var hash_scroll = '';
var filter_in_action = '';
$(document).ready(function() {
    $.ajaxSetup({ cache: false });

    $('#vac-jump').on('click', function () {
        var panel = $('#sol-button');

        $('html, body').animate({
            scrollTop: panel.offset().top
        }, 500);
        $('#vac-jump').hide();
        $('#sol-button').hide();
    });

    $('#sol-button').on('click', function () {
        var panel = $('#sol-button');

        $('html, body').animate({
            scrollTop: panel.offset().top
        }, 500);
        $('#vac-jump').hide();
        $('#sol-button').hide();
    });
	
	$('#toggle-archief').click(function(e) {
		e.preventDefault();
		//window.location.hash = 'toggle-archief';
		$('.news-110.archief .news-item').removeClass('archief');
		$(this).remove();
		hash_tops = [];
		$('.news-110.archief .hash').each(function( index ) {
			hash_tops.push({'name': $(this).data('hash'), 'value' : $(this).offset().top});
			if (hash_scroll == $(this).data('hash')) $(window).scrollTop( $(this).offset().top );
		});
		console.log(hash_tops);
	});
	if (window.location.hash == '#toggle-archief') {
		$('#toggle-archief').trigger('click');
	};
	if (window.location.hash.indexOf('#rij-') == 0) {
		hash_scroll = window.location.hash.replace('#', '');
		$('#toggle-archief').trigger('click');
		
	};

	$('#toggle-search, #close-search').click(function(e){
	    e.preventDefault();
	    $('.header-options, .header .search').toggleClass('hidden');
    });

    $('input[name="searchfor"]').autoComplete({
        source: function(term, response){
            $.getJSON(window.base_seourl + '/engine/autocomplete.php', { q: term }, function(data){
                response(data.results);
            });
        },
        cache: false
    });

    // SLIDER interactie
    $('.top-carrousel ul').bxSlider({
        mode: 'fade',
        pager: false,
        controls: false,
        auto: true,
        //nextSelector: $('.pageheader .next_btn'),
        //prevSelector: $('.pageheader .prev_btn'),
        nextText: '',
        prevText: '',
        touchEnabled: false,
        onSlideAfter: function (currentSlideNumber, totalSlideQty, currentSlideHtmlObject) {
            $('.active-slide').removeClass('active-slide');
            var nextSlide = currentSlideHtmlObject; //(currentSlideHtmlObject < $('.top-carrousel li').length - 1) ? currentSlideHtmlObject : 0;
            $('.top-carrousel li').eq(nextSlide).addClass('active-slide')
        },
        onSliderLoad: function () {
            $('.top-carrousel li').eq(0).addClass('active-slide')
        }
    });

    $('.projecten-259 ul').bxSlider({
        mode: 'horizontal',
        pager: false,
        controls: false,
        auto: true,
        //nextSelector: $('.pageheader .next_btn'),
        //prevSelector: $('.pageheader .prev_btn'),
        nextText: '',
        prevText: '',
        minSlides:2,
        maxSlides: 6,
        slideWidth: 170,
        touchEnabled: true
    });

    $('.toggle-play').click(function(e) {
        $(this).toggleClass('active');

        if($(this).hasClass('active')){
            console.log('play');
            homeslider.startAuto();
        }else{
            console.log('pause');
            homeslider.stopAuto();
        }
    });

    $(".fancybox").fancybox();

    // SLIDER interactie
    /*var prodslides = $('.product-fotos').bxSlider({
        pagerCustom: '#bx-pager-product-fotos',
        mode: 'fade',
        controls: false,
        auto: false,
        touchEnabled: false
    });
    $('.product-stalen').bxSlider({
        pager: false,
        controls: true,
        auto: true,
        touchEnabled: false,
        onSlideNext: function($slideElement, oldIndex, newIndex){
            prodslides.goToNextSlide();
        },
        onSlidePrev: function($slideElement, oldIndex, newIndex){
            prodslides.goToPrevSlide();
        }
    });*/


    $('.block').fitVids();


    //equalHeights('.quote-item', '.quotes-224 .col1');
    equalHeights('.banner','.page-home .banners-122');
    equalHeights('.colorblock', '.project-page-subinfo');
	equalHeights('.project', '.project-list');
    //imagesToBackground();

    /*
    Create dynamic BXslider
    Needed for blocks: 100
    */
    createBXslider('.bxslider');

    /*
    Extra content toggle
    Needed for blocks: 15
    */
    $('.toggle_extra_content a').click(function(e) {
        //$(this).fadeToggle();
        e.preventDefault();
        $(this).toggleClass('up down');
        $(this).parent().parent().parent().find('.extra_content').slideToggle();
    });

    /*$('.blog-masonry').masonry({
        itemSelector: '.news-item',
        percentPosition: true
    });*/
    /*
    Order masonry style
    Needed for blocks: ... (none yet)
    */
    /*
    $('.blocklist').masonry({
        // options
        itemSelector: 'article'
        //,columnWidth: 33%
    });*/

    /*
    Gmap3 functionality
    Needed for blocks: 130, 131
    */
    /*
    $('.gmap').each(function( index ) {
        gmap_address = $(this).data('address');
        //console.log(gmap_address);
        $(this).gmap3({
            marker: {
                address: gmap_address,
                events: {
                    click: function(marker, event, data) {
                        window.open("https://maps.google.com/?daddr="+gmap_address);
                    }
                }
            },
            map:{
                options:{
                    zoom:16,
                    scrollwheel: false,
                }
            }
        });
    });
*/
    $('.gmap').each(function( index ) {
        var gmap_address = $(this).data('address');
        var map_el = this;
        $.get('https://nominatim.openstreetmap.org/search?format=json&q=' + gmap_address, function (data) {
            if (data.length == 1) {

                var mymap = L.map(map_el).setView([data[0].lat, data[0].lon], 16);
                L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                }).addTo(mymap );
                var target = L.latLng(data[0].lat, data[0].lon);
                L.marker(target).on('click', function() {
                    window.open("https://maps.google.com/?daddr="+gmap_address);
                }).addTo(mymap);

            }
        }, 'json');
    });
    var mymap = L.map('footer-map', { zoomControl: false, scrollWheelZoom: false }).setView([51.5861082, 5.3113917], 16);
    L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(mymap );
    var target = L.latLng('51.5861082', '5.3113917');
    L.marker(target).addTo(mymap);
    // var filterOnLoad = window.location.hash ? '.'+(window.location.hash).replace('#','') : 'all';
    //if (typeof filterOnLoad == 'undefined') var filterOnLoad = 'all';
    if ($('#projectennnn-mix').length > 0)
    {
        $('#projecten-mix').mixItUp({
            controls: {
                enable: true
            },
            load: {
                filter: filterOnLoad,
            }
        });
    }
    // var filterOnLoad = window.location.hash ? '.'+(window.location.hash).replace('#','') : 'all';
	//if (typeof filterOnLoad == 'undefined') var filterOnLoad = 'all';
	if ($('#projecten-mix').length > 0)
	{
		$('#projecten-mix').mixItUp({
			controls: {
				enable: true
			},
			load: {
				filter: filterOnLoad,
			},
            callbacks: {
                onMixEnd: function(state) {
                    setperpage(state);
                }
            }
		});
        //setperpage();
	}

    $('#bs-menu a[href*="#"]').click(function(e) {
        e.preventDefault();
        var parts = $(this).prop('href').split('#');
        var hash = parts[1];
        if ($('.project-filters a.filter').filter('[data-filter=".'+ hash +'"]').length > 0)
        {
            $('.project-filters a.filter').filter('[data-filter=".'+ hash +'"]').trigger('click');
        } else
        {
            window.location.href = $(this).prop('href');
        }
    });

    $('.project-fotos').bxSlider({
        pager: false,
        controls: true,
        auto: true,
        touchEnabled: false
    });


    $('a.filter').click(function(e) {
        e.preventDefault();
        // window.location.hash = $(this).data('filter').replace('.', '');
        window.history.pushState('', '', $(this).prop('href'));
    });


    $("#project-filter").keyup(function(){
        // Delay function invoked to make sure user stopped typing
        delay(function(){
            var $matching = $();
            var inputText = $('#project-filter').val().toLowerCase();

            // Check to see if input field is empty
            if ((inputText.length) > 0) {
                $( '.mix').each(function() {
                    // add item to be filtered out if input text matches items inside the title

                    if($(this).text().toLowerCase().match(inputText)) {
                        $matching = $matching.add(this);
                    }
                    else {
                        // removes any previously matched item
                        $matching = $matching.not(this);
                    }
                });
                $("#projecten-mix").mixItUp('filter', $matching);
            }

            else {
                // resets the filter to show all item if input is empty
                $("#projecten-mix").mixItUp('filter', 'all');
            }
        }, 200 );
    });

    $("#contact-form").validate({
        submitHandler: function(form) {
            $('.alert-danger', form).addClass('hidden');
            $('.alert-success', form).addClass('hidden');
            $.post(window.base_url +"engine/contact.php", $(form).serializeArray(), function(data){
                if(data.succes)
                {
                    $('.alert-success', form).removeClass('hidden');
                    $(form)[0].reset();
                } else
                {
                    $('.alert-danger', form).removeClass('hidden');
                }
            }, 'json');
        }
    });

    
    $("#login-form").validate({
        submitHandler: function(form) {
            if ($('button', form).text() == 'Inloggen')
            {
                $('button', form).text('Bezig met inloggen');
                $('.alert-danger', form).addClass('hidden');
                $('.alert-success', form).addClass('hidden');
                $.post(window.base_url +"engine/login.php", $(form).serializeArray(), function(data){
                    if(data.succes)
                    {
                        $('.alert-success', form).removeClass('hidden');
                        window.location.href = window.location.href;
                    } else
                    {
                        $('.alert-danger', form).removeClass('hidden');
                    }
                    $('button', form).text('Inloggen');
                }, 'json');
            }
        }
    });
	
	$('#form-event-klant input[name=aanwezig]').click(function(e) {
		var status = $(this).val();
        if (status == 'aanwezig')
		    $('input.optional, label.optional').addClass('required');
        else
            $('input.optional, label.optional').removeClass('required');
	});

	$("#form-event-klant").validate({
        submitHandler: function(form) {
            if ($('button', form).text() == 'Reageren')
            {
                $('button', form).text('Reactie wordt verwerkt');
                $('.alert-danger', form).addClass('hidden');
                $('.alert-success', form).addClass('hidden');
                $.post(window.base_url +"engine/event_klant.php", $(form).serializeArray(), function(data){
                    if(data.succes)
                    {
						var submitval = $('#form-event-klant input[name=aanwezig]:checked').val();
						$('#submit-' + submitval).addClass('in');
                        $(form).remove();
                    } else
                    {
                        $('.alert-danger', form).removeClass('hidden');
                    }
                }, 'json');
            }
        }
    });
	
	$('#form-event-personeel input[name=aanwezig]').click(function(e) {
		var status = $(this).val();
		$('#form-event-klant .collapse').removeClass('in');
		$('#aanwezig-' + status).addClass('in');
	});
    // if aantal_kinderen changes value , show kind form groups for correct number
    $('#aantal_kinderen').change(function(e) {
        var aantal = $(this).val();
        $('.kinderen').addClass('hidden');
        for(i = 1; i<=aantal; i++) {
            $('#kind-' + i).removeClass('hidden');
        }
    });

	$("#form-event-personeel").validate({
        submitHandler: function(form) {
            if ($('button', form).text() == 'Reageren')
            {
                $('button', form).text('Reactie wordt verwerkt');
                $('.alert-danger', form).addClass('hidden');
                $('.alert-success', form).addClass('hidden');
                $.post(window.base_url +"engine/event_pers.php", $(form).serializeArray(), function(data){
                    if(data.succes)
                    {
						var submitval = $('#form-event-personeel input[name=aanwezig]:checked').val();
						$('#submit-' + submitval).addClass('in');
                        $(form).remove();
                    } else
                    {
                        $('.alert-danger', form).removeClass('hidden');
                    }
                }, 'json');
            }
        }
    });
    $('#form-event-vriend input[name=aanwezig]').click(function(e) {
        var status = $(this).val();
        $('#form-event-vriend .collapse').removeClass('in');
        $('#aanwezig-' + status).addClass('in');
    });
    $("#form-event-vriend").validate({
        submitHandler: function(form) {
            if ($('button', form).text() == 'Reageren')
            {
                $('button', form).text('Reactie wordt verwerkt');
                $('.alert-danger', form).addClass('hidden');
                $('.alert-success', form).addClass('hidden');
                $.post(window.base_url +"engine/event_vriend.php", $(form).serializeArray(), function(data){
                    if(data.succes)
                    {
                        var submitval = $('#form-event-vriend input[name=aanwezig]:checked').val();
                        $('#submit-' + submitval).addClass('in');
                        $(form).remove();
                    } else
                    {
                        $('.alert-danger', form).removeClass('hidden');
                    }
                }, 'json');
            }
        }
    });

	$('#form-event-pv input[name=aanwezig_status]').click(function(e) {
		var status = $(this).val();
		$('#form-event-pv .collapse').removeClass('in');
		$('#aanwezig-' + status).addClass('in');
	});

	
	$("#form-event-pv").validate({
        submitHandler: function(form) {
            if ($('button', form).text() == 'Versturen')
            {
                $('button', form).text('Bezig met versturen');
                $('.alert-danger', form).addClass('hidden');
                $('.alert-success', form).addClass('hidden');
                $.post(window.base_url +"engine/pvevent.php", $(form).serializeArray(), function(data){
                    if(data.succes)
                    {
						var submitval = $('#form-event-pv input[name=aanwezig_status]:checked').val();
						$('#submit-' + submitval).addClass('in');
                        $(form).remove();
                    } else
                    {
                        $('.alert-danger', form).removeClass('hidden');
						$('button', form).text('Versturen');
                    }
                }, 'json');
            }
        }
    });
	
    $("#vacature-form").validate({
        submitHandler: function(form) {
			
            $('.alert-danger', form).addClass('hidden');
            $('.alert-success', form).addClass('hidden');
			ga('send', 'event', 'Form', 'Vacature', $('#vacature_naam').val());
            $(form).prop('method', 'POST');
            $(form).prop('target', 'hiddenframe');
            $(form).prop('action', window.base_url + "engine/vacature-formulier.php");
            var $iframe = $('<iframe>');
            $iframe.prop('id', 'hiddenframe');
            $iframe.prop('name', 'hiddenframe');
            $iframe.hide();
            $iframe.appendTo('body');
            form.submit();
        }
    });

});

$(document).scroll(function() { 
	/*var hash = window.location.hash;
	var new_hash = '';
	for(i = 0; i < hash_tops.length; i++) {
		if (hash_tops[i].value < $(window).scrollTop()) new_hash = '#'+hash_tops[i].name;
	}
	if (hash != new_hash) window.location.hash = new_hash; 
	*/
});

$( window ).resize(function() {
    //equalHeights('.banner','.banners-123');


});

/*
iFrame form handlers
Needed for module vacature
*/
function iframeform_success(form) {
    $('.alert-success').removeClass('hidden');
    $(form)[0].reset();
    $('#hiddenframe').remove();
}

function iframeform_error() {
    $('.alert-danger').removeClass('hidden');
    $('#hiddenframe').remove();
}


function initCoverflow(elm) {

    coverflow = new FWDSimple3DCoverflow(
        {
            //required settings
            coverflowHolderDivId: elm,
            coverflowDataListDivId:"coverflowData",
            displayType:"responsive",
            autoScale:"yes",
            coverflowWidth:940,
            coverflowHeight:560,
            skinPath:"images/coverflow/skin_white",

            //main settings
            backgroundColor:"transparent",
            backgroundImagePath:"",
            backgroundRepeat:"repeat-x",
            showDisplay2DAlways:"no",
            coverflowStartPosition:$('#'+elm).data('cf-startslide'),
            coverflowTopology:$('#'+elm).data('cf-mode'),
            coverflowXRotation:0,
            coverflowYRotation:0,
            numberOfThumbnailsToDisplayLeftAndRight:"5",
            infiniteLoop:$('#'+elm).data('cf-loop'),
            rightClickContextMenu:"default",

            //thumbnail settings
            thumbnailWidth:300,
            thumbnailHeight:500,
            thumbnailXOffset3D:86,
            thumbnailXSpace3D:78,
            thumbnailZOffset3D:200,
            thumbnailZSpace3D:93,
            thumbnailYAngle3D:0,
            thumbnailXOffset2D:20,
            thumbnailXSpace2D:30,
            thumbnailHoverOffset:100,
            thumbnailBorderSize:0,
            thumbnailBackgroundColor:"#999999",
            thumbnailBorderColor1:"#FFFFFF",
            thumbnailBorderColor2:"#000000",
            transparentImages:"yes",
            thumbnailsAlignment:"center",
            maxNumberOfThumbnailsOnMobile:13,
            showThumbnailsGradient:"yes",
            thumbnailGradientColor1:"rgba(0, 0, 0, 0)",
            thumbnailGradientColor2:"rgba(0, 0, 0, 0)",
            showText:"yes",
            textOffset:10,
            showThumbnailBoxShadow:"yes",
            thumbnailBoxShadowCss:"0 3px 4px 0 rgba(0,0,0,0.5)",
            showTooltip:"no",
            dynamicTooltip:"yes",
            showReflection:"no",
            reflectionHeight:60,
            reflectionDistance:0,
            reflectionOpacity:.4,

            //controls settings
            slideshowDelay:$('#'+elm).data('cf-pause'),
            autoplay:$('#'+elm).data('cf-autoplay'),
            disableNextAndPrevButtonsOnMobile:"no",
            controlsMaxWidth:700,
            slideshowTimerColor:"#FFFFFF",
            controlsPosition:"bottom",
            controlsOffset:15,
            showPrevButton:$('#'+elm).data('cf-controls'),
            showNextButton:$('#'+elm).data('cf-controls'),
            showSlideshowButton:$('#'+elm).data('cf-controls'),
            showScrollbar:$('#'+elm).data('cf-pager'),
            disableScrollbarOnMobile:"yes",
            enableMouseWheelScroll:"yes",
            scrollbarHandlerWidth:200,
            scrollbarTextColorNormal:"#000000",
            scrollbarTextColorSelected:"#FFFFFF",
            addKeyboardSupport:"yes",

            //categories settings
            showCategoriesMenu:"no",
            startAtCategory:1,
            categoriesMenuMaxWidth:700,
            categoriesMenuOffset:25,
            categoryColorNormal:"#999999",
            categoryColorSelected:"#FFFFFF",

            //lightbox settings
            addLightBoxKeyboardSupport:"yes",
            showLightBoxNextAndPrevButtons:"yes",
            showLightBoxZoomButton:"yes",
            showLightBoxInfoButton:"yes",
            showLightBoxSlideShowButton:"yes",
            showLightBoxInfoWindowByDefault:"no",
            slideShowAutoPlay:"no",
            lightBoxVideoAutoPlay:"no",
            lightBoxVideoWidth:640,
            lightBoxVideoHeight:480,
            lightBoxIframeWidth:800,
            lightBoxIframeHeight:600,
            lightBoxBackgroundColor:"#000000",
            lightBoxInfoWindowBackgroundColor:"#FFFFFF",
            lightBoxItemBorderColor1:"#fcfdfd",
            lightBoxItemBorderColor2:"#e4FFe4",
            lightBoxItemBackgroundColor:"#333333",
            lightBoxMainBackgroundOpacity:.8,
            lightBoxInfoWindowBackgroundOpacity:.9,
            lightBoxBorderSize:0,
            lightBoxBorderRadius:20,
            lightBoxSlideShowDelay:4000

        });
}

function createBXslider(elm){
    $(elm).each(function(index) {
        c_id = $(this).attr('id');
        //console.log(c_id);
        var options = {};
        options.mode = $(this).data('bx-mode');
        options.auto = $(this).data('bx-auto');
        options.pause = $(this).data('bx-pause');
        options.loop = $(this).data('bx-loop');
        options.pager = $(this).data('bx-pager');
        options.controls = $(this).data('bx-controls');
        options.ticker = $(this).data('bx-ticker');
        options.speed = $(this).data('bx-speed');
        options.minSlides  = $(this).data('bx-minslides') ? $(this).data('bx-minslides') : 1;
        options.maxSlides  = $(this).data('bx-maxslides') ? $(this).data('bx-maxslides') : 1;
        options.slideWidth  = $(this).data('bx-slidewidth') ? $(this).data('bx-slidewidth') : 0;

        options.nextText = '';
        options.prevText = '';
        console.log(options);
        $(this).bxSlider(options);
    });
    return;

    car_id = $(elm).attr('id');
    var cms_options = 'options_'+car_id;
    this[cms_options].value++;
    //console.log(this[cms_options]);
    var options = {};

    // auto
    if ('auto' in this[cms_options]) {
        switch(this[cms_options].auto){
            case '1':
                options.auto = true;
                break;
            default:
                options.auto = false;
        }
    }else{
        options.auto = true;
    }

    // mode
    if ('mode' in this[cms_options]) {
        switch(this[cms_options].mode){
            case '0':
                options.mode = 'fade';
                break;
            case '2':
                options.mode = 'vertical';
                break;
            case '3':
                options.mode = 'horizontal';
                options.ticker = true;
                options.speed = 8000;
                break;
            default:
                options.mode = 'horizontal';
        }
    }else{
        options.mode = 'horizontal';
    }

    //console.log(options);

    $('#'+car_id).bxSlider(options);
}

// set <img src> as a css background-image
/*function imagesToBackground(){
    $('.image-on-bg').each(function() {
        var imageUrl = $(this).find('img').first().attr('src');
        imageUrl = encodeURI(imageUrl);
        $(this).find('img').first().remove();
        $(this).css('background-image', 'url(' + imageUrl + ')');
    });
}*/

function imagesToBackground(){
    $('.image-to-bg').each(function() {
        //var imageHeight = $(this).attr('height');
        var imageUrl = $(this).attr('src');
        imageUrl = encodeURI(imageUrl);
        var parentElement = $(this).closest('div');
        parentClass = '.'+$(this).closest('section').attr('class').split(' ').pop();
        $(this).remove();
        parentElement.addClass('image-block').css('background-image', 'url(' + imageUrl + ')');
        equalHeights('.block > div', parentClass);
    });
}

function equalHeights(element, container){
    if (typeof container === 'undefined') {
        c = $(element).parent();
    } else {
        c = $(container);
    }

    var highestBox = 0;
    c.find(element).each(function(){
        if($(this).height() > highestBox){
            highestBox = $(this).height();
        }
    })
    c.find(element).height(highestBox);

}

/*
function placeholderFallback() {
    if(!Modernizr.input.placeholder) {
        $("input[placeholder], textarea[placeholder]").each(function() {
            if($(this).val()==""){
                $(this).val($(this).attr("placeholder"));
                $(this).focus(function(){
                    if($(this).val()==$(this).attr("placeholder")) {
                        $(this).val("");
                        $(this).removeClass('placeholder');
                    }
                });
                $(this).blur(function(){
                    if($(this).val()==""){
                        $(this).val($(this).attr("placeholder"));
                        $(this).addClass('placeholder');
                    }
                });
            }
        });
        $('form').submit(function(){
            // first do all the checking for required element and form validation.
            // Only remove placeholders before final submission
            var placeheld = $(this).find('[placeholder]');
            for(var i=0; i<placeheld.length; i++){
                if($(placeheld[i]).val() == $(placeheld[i]).attr('placeholder')) {
                    // if not required, set value to empty before submitting
                    $(placeheld[i]).attr('value','');
                }
            }
        });
    }
}*/


// Delay function
var delay = (function(){
    var timer = 0;
    return function(callback, ms){
        clearTimeout (timer);
        timer = setTimeout(callback, ms);
    };
})();

$.validator.setDefaults({
    highlight: function(element) {
        $(element).closest('.form-group').addClass('has-error');
    },
    unhighlight: function(element) {
        $(element).closest('.form-group').removeClass('has-error');
    },
    errorElement: 'span',
    errorClass: 'help-block',
    errorPlacement: function(error, element) {
        if(element.parent('.input-group').length) {
            //error.insertAfter(element.parent());
            error.appendTo(element.parent().parent());
        } else {
            error.insertAfter(element);
        }
    }
});


function setperpage(state) {
    filter_in_action = state.activeFilter;
    var itemsPerPage = 12;
    var filter_actie = $('.project-filters .filter.active').data('filter');
    var mixer = (filter_actie == 'all') ? '.mix' : filter_actie;
    var status = state;
    var totalItems = $(mixer).length;
    var totalPages = Math.ceil(totalItems / itemsPerPage);

    // Function to get query parameter by name
    function getQueryParam(param) {
        var urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    // Function to update query string without reloading the page
    function updateQueryString(key, value) {
        var url = new URL(window.location);
        url.searchParams.set(key, value);
        window.history.pushState({ path: url.href }, '', url.href);
    }

    // Function to show a specific page
    function showPage(pageNumber) {
        // Clamp pageNumber to range 1 to totalPages
        pageNumber = Math.max(1, Math.min(totalPages, pageNumber));
        if (filter_in_action != mixer) return;
        var start = (pageNumber - 1) * itemsPerPage;
        var end = start + itemsPerPage;
        
        $(mixer).each(function(index) {
            if (index >= start && index < end) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });

        // Disable or enable pagination buttons
        if (pageNumber === 1) $('#prevPage').addClass('hidden'); else $('#prevPage').removeClass('hidden');
        if (pageNumber === totalPages) $('#nextPage').addClass('hidden'); else $('#nextPage').removeClass('hidden');

        // Update the query string with the current page number
        updateQueryString('page', pageNumber);
    }

    // Determine the initial page from query string or default to 1
    var initialPage = parseInt(getQueryParam('page')) || 1;

    // Initial page display
    showPage(initialPage);

    // Pagination controls
    $('#nextPage').on('click', function() {
        showPage(initialPage + 1);
        initialPage++;
    });

    $('#prevPage').on('click', function() {
        showPage(initialPage - 1);
        initialPage--;
    });
}
